import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Star } from 'lucide-react';
const CREDENTIALS = ['LL.B', 'B.A', 'LLM', 'Commercial Law Accredited Specialist'];
export function TeamAuthority() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-background" data-id="element-393">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-394">
        {/* Portrait */}
        <div className="lg:col-span-5 order-2 lg:order-1" data-id="element-395">
          <div className="relative max-w-md mx-auto lg:mx-0" data-id="element-396">
            <div className="overflow-hidden rounded-4xl shadow-warm" data-id="element-397">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=80" alt="Professional portrait placeholder for Linda Ashley, Principal Solicitor" className="w-full h-[440px] object-cover" loading="lazy" data-id="element-398" />
            </div>
            <div className="absolute -bottom-5 left-5 right-5 sm:left-auto sm:right-6 sm:w-60 bg-surface rounded-2xl border border-border shadow-subtle p-4" data-id="element-399">
              <div className="flex items-center gap-1 text-accent mb-1" data-id="element-400">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5" fill="currentColor" data-id="element-401" />)}
              </div>
              <p className="text-sm text-ink leading-snug" data-id="element-402">
                "Thorough, responsive and knowledgeable."
              </p>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-7 order-1 lg:order-2" data-id="element-403">
          <p className="text-accent font-script text-2xl mb-1" data-id="element-404">
            a real person, not a portal
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-405">
            Legal advice from people you can identify.
          </h2>
          <p className="mt-3 text-xl text-ink font-semibold" data-id="element-406">
            Linda Ashley, Principal Solicitor.
          </p>
          <p className="mt-5 text-lg text-muted-ink leading-relaxed max-w-xl" data-id="element-407">
            Linda's associated firm profile describes experience across
            property, commercial transactions, trusts, SMSFs, contracts and
            related disputes. You deal with a solicitor who knows your matter,
            not a rotating queue.
          </p>

          {/* Confirm all qualification, admission and accreditation wording before production launch. */}
          <div className="mt-7 flex flex-wrap gap-2" data-id="element-408">
            {CREDENTIALS.map(c => <span key={c} className="rounded-full bg-soft-panel border border-border px-3.5 py-1.5 text-sm font-medium text-ink" data-id="element-409">
                {c}
              </span>)}
          </div>

          <div className="mt-8" data-id="element-410">
            <Link to="/team" data-id="element-411">
              <Button variant="primary" data-id="element-412">Meet the legal team</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}